import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExportExcelService {
  constructor() {}

  async exportToExcel(
    data: any[],
    fileName: string,
    columns?: { header: string; key: string; width?: number }[],
    headerRows?: string[][],
    sheetName: string = 'Sheet1'
  ): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    // Add blank rows (1-3)
    worksheet.addRows([[], [], []]);

    // Row 4: Details Items (merged A-J)
    worksheet.addRow([headerRows?.[0]?.[0] || ': : Details Items : :']);
    worksheet.mergeCells('A4:J4');

    // Row 5: blank
    worksheet.addRow([]);

    // Row 6: P&A No (merged A-J)
    worksheet.addRow([headerRows?.[1]?.[0] || '']);
    worksheet.mergeCells('A6:J6');

    // Row 7: blank
    worksheet.addRow([]);

    // Row 8: Table header
    const colDefs =
      columns && columns.length > 0
        ? columns
        : Object.keys(data[0] || {}).map((key) => ({
            header: key,
            key,
            width: 20,
          }));
    colDefs.forEach((col, idx) => {
      worksheet.getColumn(idx + 1).width = (col as any).width || 20;
    });
    const headerRow = worksheet.addRow(colDefs.map((col) => col.header));
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    // Add border to header row
    headerRow.eachCell((cell: any) => {
      cell.border = {
        top: { style: 'medium' },
        left: { style: 'medium' },
        bottom: { style: 'medium' },
        right: { style: 'medium' },
      };
    });

    // Row 9+: Table data
    data.forEach((item) => {
      const rowData = colDefs.map((col) => item[col.key]);
      const row = worksheet.addRow(rowData);
      row.alignment = { horizontal: 'center', vertical: 'middle' };
      // Add border to data rows
      row.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'medium' },
          left: { style: 'medium' },
          bottom: { style: 'medium' },
          right: { style: 'medium' },
        };
      });
    });

    // Save file
    const buffer = await workbook.xlsx.writeBuffer();
    FileSaver.saveAs(
      new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
      `${fileName}.xlsx`
    );
  }
}
